module.exports = __webpack_public_path__ + "static/media/we3academy_gridexample_djtally.532b87d8.jpg";